import { render } from "./VehicleDetails.vue?vue&type=template&id=5521fbae&scoped=true"
import script from "./VehicleDetails.vue?vue&type=script&lang=js"
export * from "./VehicleDetails.vue?vue&type=script&lang=js"

import "../assets/css/viver-style.css?vue&type=style&index=0&id=5521fbae&scoped=true&lang=css&external"
import "./VehicleDetails.vue?vue&type=style&index=1&id=5521fbae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5521fbae"]])

export default __exports__